import React from "react";
import "./ServicePages.scss";

//Panels
import Hero from "./Components/Hero";

//Images
import steps from "./images/steps/bg-steps.jpg";
import featureA1 from "./images/steps/feature-a-1.jpg";
import featureA2 from "./images/steps/feature-a-2.jpg";
import featureA3 from "./images/steps/feature-a-3.jpg";
import featureB1 from "./images/steps/feature-b-1.jpg";
import featureB2 from "./images/steps/feature-b-2.jpg";
import featureB3 from "./images/steps/feature-b-3.jpg";
import featureC1 from "./images/steps/Rustic-Wall-Cream-Terracotta-Brown.jpg";
import featureC2 from "./images/steps/BEL2018_Coastal_Swatch_Mega_Bergerac_Harvest_Blend.jpg";
import featureC3 from "./images/steps/Stonewall-Gray-Charcoal.jpg";

//SEO
import SEO from "../../../SEO/index.js";
import StructuredData from "../../../SEO/structuredData";

const Steps = () => {
  return (
    <>
      <SEO
        title="Outdoor Steps Design | Stone & Concrete | Pacific Pavingstone"
        description="Depending on your home’s aesthetic, there are two major options for steps and coping; Paving stones or Poured concrete. Request an estimate today!"
        profileURL={
          "https://www.pacificpavingstone.com/services/steps-and-coping"
        }
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "Service",
          name: "Outdoor Steps Design",
          image:
            "https://www.pacificpavingstone.com/static/media/bg-steps.a8b10d27.jpg",
          description:
            "Depending on your home’s aesthetic, there are two major options for steps and coping; Paving stones or Poured concrete. Request an estimate today!",
          brand: "Pacific Pavingstone",
          areaServed: "Southern California",
          logo: "https://www.pacificpavingstone.com/static/media/logo-2.bf1f43f9.png",
          provider: "Pacific Pavingstone",
          URL: "https://www.pacificpavingstone.com/services/steps-and-coping",
          potentialAction: "Schedule a Consultation",
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5",
            bestRating: "5",
            worstRating: "1",
            ratingCount: "1",
            reviewCount: "1",
          },
          review: {
            "@type": "Review",
            name: "R.R.",
            reviewBody:
              "Every once in a while I come across a contractor whose standards are exceptional on all levels. Pacific Pavingstone is one of those contractors! They recently installed an 1,100 sq ft paver stone driveway, numerous cantilevered concrete steps, board formed concrete planter walls and landscaping that is of the highest quality and that we just LOVE! Furthermore, Trent, John, Luis and their entire staff were always a pleasure to work with and the entire experience was easy and stress-free too! If you want a contractor that is professional, does outstanding quality work and one that you will not lose any sleep over, Pacific Pavingstone is the one for you!",
            reviewRating: {
              "@type": "Rating",
              ratingValue: "5",
              bestRating: "5",
              worstRating: "1",
            },
            datePublished: "2021-10-08",
            author: { "@type": "Person", name: "R.R." },
            publisher: { "@type": "Organization", name: "Pacific Pavingstone" },
          },
        }}
      />
      <div className="container-fluid page-featured">
        <Hero title={"Steps and Coping"} background={steps} />
        <div className="row justify-content-center">
          <div className="col-11 col-md-9">
            <div className="row justify-content-center panel-content pb-4">
              <div className="col-12">
                <p>
                  To create a cohesive look for your outdoor living space you
                  can’t forgot about your walkway steps and coping. This is
                  often an overlooked outdoor area and can change the entire
                  dynamic of your space. Steps and coping not only serve a
                  functional purpose but can also add depth to your yard. If
                  you’re undergoing an entire backyard renovation be sure to
                  plan ahead of time to make sure the steps are made out of the
                  same material as the rest of the space.
                  <br />
                  <br />
                  Depending on your home’s aesthetic, there are two major
                  options for steps and coping; Paving stones or Poured
                  concrete.
                </p>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12">
                <h2 className="text-center text-uppercase mb-4">
                  Paving Stones
                </h2>
                <p>
                  Paving stones are a versatile material and ideal for steps,
                  walkways and patios. They are extremely durable, long lasting
                  and slip-resistant (an important factor when choosing your
                  material). Paving stones come in an array of styles, shapes
                  and colors.
                  <br />
                  <br />
                  Typically, the stones are chosen to match the rest of the
                  house or outdoor space and the design is outlined with a
                  darker stone so you can tell where the step ends in low-light.
                </p>
              </div>
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA1}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA2}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA3}
                      alt="Featured"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12">
                <h2 className="text-center text-uppercase mb-4">
                  Poured Concrete
                </h2>
                <p>
                  Poured concrete lends itself to a more modern look when used
                  for steps and coping. It is a great material to use to get a
                  contemporary or modern aesthetic. Poured Concrete is an
                  economical option for steps and can be mixed in different
                  color variants or stamped for a textured look. Poured concrete
                  coupled with outdoor lighting within the step is not only
                  useful but also looks clean, geometrical and ultra modern.
                  Poured concrete is also a great option for steps around pools
                  as it is a slip-resistant surface as well.
                </p>
              </div>
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB1}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB2}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB3}
                      alt="Featured"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style">
                      <img
                        className="mb-2 mb-lg-0"
                        src={featureC1}
                        alt="Angelus Rustic Wall Stone In Cream Terracotta Brown"
                      />
                      <div className="text">
                        <p>
                          Angelus Rustic Wall Stone
                          <br />
                          In Cream Terracotta Brown
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style">
                      <img
                        className="mb-2 mb-lg-0"
                        src={featureC2}
                        alt="Belgard Mega-Bergerac® In Harvest Blend"
                      />
                      <div className="text">
                        <p>
                          Belgard Mega-Bergerac®
                          <br />
                          In Harvest Blend
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style">
                      <img
                        className="mb-2 mb-lg-0"
                        src={featureC3}
                        alt="Angelus Stonewall® II Olympic Series In Gray Charcoal"
                      />
                      <div className="text">
                        <p>
                          Angelus Stonewall® II Olympic Series
                          <br />
                          In Gray Charcoal
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Steps;
